import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-collapse" }
const _hoisted_2 = { class: "p-4 pt-8" }

import { onMounted, onUnmounted, ref, watch } from "vue";
import { useVModel } from "@vueuse/core";
import UiTappable from "@/plugins/ui/components/tappable/UiTappable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiCollapse',
  props: {
  modelValue: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props



let observer: MutationObserver;

const show = ref(props.modelValue);
const bodyRef = ref<HTMLDivElement>();
const maxHeight = ref<number>();
const showModel = useVModel(props, "modelValue");

function calcHeight() {
  maxHeight.value = show.value ? bodyRef.value?.scrollHeight : 0;
}

watch(
  () => show.value,
  (value) => {
    calcHeight();
    showModel.value = value;
  }
);

onMounted(() => {
  observer = new MutationObserver(calcHeight);
  observer.observe(bodyRef.value!, { childList: true, subtree: true });
  calcHeight();
});

onUnmounted(() => {
  observer.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.header)
      ? (_openBlock(), _createBlock(UiTappable, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = !show.value)),
          class: "ui-collapse__header -mt-4 mb-4 p-4 -mx-4"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "header")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "bodyRef",
      ref: bodyRef,
      class: "ui-collapse__body",
      style: _normalizeStyle({
        maxHeight: maxHeight.value + 'px',
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 4)
  ]))
}
}

})